<template>
  <v-main class="bg-background" scrollable>
    <div class="ma-4" data-testid="so-admin-page">
      <div
        class="d-flex align-end justify-space-between my-5 pt-5"
        data-testid="so-admin-page-header"
      >
        <div>
          <div class="d-flex align-center ga-2 mb-3">
            <SoButton
              v-if="backTo"
              icon="arrow-left"
              type="icon"
              data-testid="admin-page-back"
              @click="$router.push(backTo)"
            />
            <div class="text-h2" data-testid="title">{{ title }}</div>
            <slot name="titleAppend"></slot>
          </div>
          <div
            class="text-h6"
            :class="{ 'subtitle-indented': backTo }"
            data-testid="subtitle"
          >
            <slot name="subtitle">{{ subtitle }}</slot>
          </div>
        </div>
        <slot name="headerRight"></slot>
      </div>
      <slot></slot>
    </div>
  </v-main>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { RouteLocationRaw } from "vue-router"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: { SoButton },
    props: {
      title: {
        type: String,
        default: null,
      },
      subtitle: {
        type: String,
        default: null,
      },
      backTo: {
        type: [String, Object] as PropType<RouteLocationRaw>,
        default: null,
      },
    },
  })
</script>

<style scoped>
  /* Align the subtitle with the title when the back-button icon (36px + 8px gap)
     offsets the title. */
  .subtitle-indented {
    padding-left: 44px;
  }
</style>
